<script lang="ts">
import { ContratStatuts } from '@/generated/classes/Contrat';
import { PaieStatuts } from '@/generated/classes/Paie';
import SectionProjet from '@/generated/sections/SectionProjet.vue';
import { storeContrat, storePaie } from '@/generated/stores';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: SectionProjet,
    computed: {
        fields(): string[] {
            return ['NOM', 'NUMERO_OBJET_ID', 'ETABLISSEMENT_ID', 'GRAPH_CONTROL'];
        }
    },
    methods: {
        readOnly(value: string): boolean {
            let res = false;
            if (!this.editProjet.canUpdate) {
                return true;
            }
            if (this.readOnlyMap.size == 0) {
                const contrats = storeContrat.listContrat.filter(a => a.projetId == this.editProjet.id && a.statut >= ContratStatuts.SUBMITTED);
                const paies = storePaie.listPaie.filter(a => a.projetId == this.editProjet.id && a.statut >= PaieStatuts.APPROVED);
                const cantChange = contrats.length > 0 || paies.length > 0;
                this.readOnlyMap.set("NOM", false);
                this.readOnlyMap.set("NUMERO_OBJET_ID", false);
                this.readOnlyMap.set("ETABLISSEMENT_ID", cantChange);
                this.readOnlyMap.set("GRAPH_CONTROL", cantChange);
            }
            const readOnly = this.readOnlyMap.get(value);
            if (readOnly != undefined) {
                res = readOnly;
            }
            return res;
        },
      isDisplayed (value: string): boolean {
        let res = true;
        if (this.displayMap.size == 0) {
          this.displayMap.set("NOM", true);
          this.displayMap.set("NUMERO_OBJET_ID", true);
          this.displayMap.set("ETABLISSEMENT_ID", true);
        }
        const display = this.displayMap.get(value);
        if (display != undefined) {
          res = display;
        }
        return res;
      },
        fieldUpdated(field: string, value: unknown): void {
            if (field == 'ETABLISSEMENT_ID') {
                this.toggleGraph = !this.toggleGraph;
            }
        },
        picto(): string {
            return 'SectionPictoProjet'
        },
        sectionSave(): void {
            this.save();
            this.readOnlyMap.clear();
        }
    }
})

</script>
